import { Badge } from "../ui/badge";

/**
 * Maps a status string to a background color class.
 * @param {string} status
 * @returns {string} Tailwind background color class
 */
export const getStatusColor = (status) => {
  if (!status) return "bg-slate-100 text-slate-600";

  const s = status.toLowerCase();

  const styles = {
    // Success / Completed
    completed: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-400",
    verified: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-400",
    present: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-400",

    // In Progress / Active
    in_progress: "bg-blue-100 text-yale-blue-700 dark:bg-yale-blue-500/20 dark:text-yale-blue-400",
    active: "bg-blue-100 text-yale-blue-700 dark:bg-yale-blue-500/20 dark:text-yale-blue-400",
    half_day: "bg-blue-100 text-yale-blue-700 dark:bg-yale-blue-500/20 dark:text-yale-blue-400",

    // Pending / Warning
    pending: "bg-amber-100 text-yale-blue-700 dark:bg-primary/20 dark:text-yale-blue-400",
    late: "bg-amber-100 text-yale-blue-700 dark:bg-primary/20 dark:text-yale-blue-400",

    // Error / Overdue
    overdue: "bg-rose-100 text-rose-700 dark:bg-rose-500/20 dark:text-rose-400",
    delayed: "bg-rose-100 text-rose-700 dark:bg-rose-500/20 dark:text-rose-400",
    absent: "bg-rose-100 text-rose-700 dark:bg-rose-500/20 dark:text-rose-400",
    cancelled: "bg-rose-100 text-rose-700 dark:bg-rose-500/20 dark:text-rose-400",

    // Neutral / Disabled
    planning: "bg-slate-100 text-slate-600 dark:bg-yale-blue-800 dark:text-slate-400",
    not_started: "bg-slate-100 text-slate-600 dark:bg-yale-blue-800 dark:text-slate-400",
    draft: "bg-slate-100 text-slate-600 dark:bg-yale-blue-800 dark:text-slate-400",

    // Custom / Other
    on_hold: "bg-amber-100 text-yale-blue-700 dark:bg-primary/20 dark:text-yale-blue-400",
    office: "bg-purple-100 text-purple-700 dark:bg-purple-500/20 dark:text-purple-400",
    field: "bg-slate-100 text-slate-700 dark:bg-slate-500/20 dark:text-slate-400"
  };

  return styles[s] || "bg-slate-100 text-slate-600";
};

/**
 * A standard badge component for displaying statuses.
 * @param {string} status - The status text to display
 * @param {string} className - Additional CSS classes
 */
const StatusBadge = ({ status, className = "" }) => {
  if (!status) return null;

  return (
    <Badge
      variant="secondary"
      className={`border-none px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${getStatusColor(status)} ${className}`}
    >
      {status.replace(/_/g, " ")}
    </Badge>
  );
};

export default StatusBadge;
